const Footer = () => {

  const footerLinks = {
    'Personal Vehicle Finance': {
      mainLink: 'https://www.udc.co.nz/for-individuals/personal-vehicle-finance',
      links: [
        { 'Car Loans': 'https://www.udc.co.nz/for-individuals/cars/' },
        { 'Electric & Hybrid Vehicles': 'https://www.udc.co.nz/for-individuals/electric-hybrid-vehicle' },
        { 'Motorcycles': 'https://www.udc.co.nz/for-individuals/motorcycles' },
        { 'Motorhomes & Caravans': 'https://www.udc.co.nz/for-individuals/motorhomes-caravans' },
        { 'Marine Loans': 'https://www.udc.co.nz/for-individuals/marine' },
        { 'FAQs': 'https://www.udc.co.nz/help-resources/faqs' },
        { 'Customer Service': 'https://www.udc.co.nz/for-individuals/customer-service' },
        { 'Fees, Rates and Documentation': 'https://www.udc.co.nz/for-individuals/customer-service/rates-fees-and-documentation' },
        { 'Find a Dealer': 'https://www.udc.co.nz/find-a-dealer' }
      ],
      subLinks: []
    },
    'Business Asset Finance': {
      mainLink: 'https://www.udc.co.nz/for-business/business-asset-finance',
      links: [
        { 'Transport & Logistics': 'https://www.udc.co.nz/for-business/transport-logistics' },
        { 'Vehicles': 'https://www.udc.co.nz/for-business/vehicles' },
        { 'Civil Construction': 'https://www.udc.co.nz/for-business/civil-construction' },
        { 'Forestry': 'https://www.udc.co.nz/for-business/forestry' },
        { 'Fleet Finance': 'https://www.udc.co.nz/for-business/fleet-finance' },
        { 'Agriculture': 'https://www.udc.co.nz/for-business/agriculture' },
        { 'Plant & Equipment': 'https://www.udc.co.nz/for-business/plant-equipment' },
        { 'Aviation': 'https://www.udc.co.nz/for-business/aviation' },
        { 'Talk to a Specialist': 'https://www.udc.co.nz/find-specialist' },
        { 'FAQs': 'https://www.udc.co.nz/help-resources/faqs#faqs' },
        { 'Customer Service': 'https://www.udc.co.nz/for-business/customer-service' }
      ],
      subLinks: []
    },
    'About us': {
      mainLink: 'https://www.udc.co.nz/about-us/about-us',
      links: [
        { 'UDC News': 'https://www.udc.co.nz/about-us/udc-news' },
        { 'Our Team': 'https://www.udc.co.nz/our-team' },
        { 'Careers': 'https://udcfinance.csod.com/ux/ats/careersite/5/home?c=udcfinance' },
      ],
      subLinks: []
    },
    'Help & Resources': {
      mainLink: '',
      links: [
        { 'FAQs': 'https://www.udc.co.nz/help-resources/faqs' },
        { 'Contact Us': 'https://www.udc.co.nz/help-resources/contact-us' },
        { 'Dealer Finance': 'https://www.udc.co.nz/help-resources/dealer-finance' },
        { 'Flexible Business Products for your Business': 'https://www.udc.co.nz/for-business/flexible-finance-products-for-your-business' },
        { 'Manage Your Account with myUDC': 'https://www.udc.co.nz/help-resources/myudc-your-account' }
      ],
      subLinks: []
    }
  }
  
  const footerLinnksBottom = [
      { 'Home': 'https://www.udc.co.nz/' },
      { 'Calculators': 'https://www.udc.co.nz/calculators' },
      { 'Website Security & Privacy Policy': 'https://www.udc.co.nz/website-security-and-privacy-statement' },
      { 'Disclosure Statement': 'https://www.udc.co.nz/financial-advice-disclosure-statement' },
      { 'UDC Live': 'https://nz.udclive.co.nz/external/login' },
      { 'myUDC': 'https://my.udc.co.nz/?_ga=2.103920263.685964961.1658281333-1642631903.1658281333' },
  ]

  return (
    <footer className='bg-[var(--theme-bg)] text-xs'>
      <div className='bg-white py-8 px-8 lg:px-10 text-[var(--theme-text-alt)]'>
        <div className='max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-4 gap-8'>
          {Object.entries(footerLinks).map(([title, { mainLink, links, subLinks }], colIndex) => (
            <div key={colIndex}>
              <h3 className='mb-3'>
                <a href={mainLink} className='text-[var(--brand-1)] [@media(hover:hover)]:hover:underline'>{title}</a>
              </h3>
              <ul className='space-y-2.5 md:space-y-1.5'>
                {links.map((link, index) => (
                  <li key={index}>
                    <a className='[@media(hover:hover)]:hover:underline' href={Object.values(link)[0] as string}>{Object.keys(link)[0]}</a>
                  </li>
                ))}
              </ul>
              {subLinks.length > 0 && (
                <ul className='space-y-2.5 md:space-y-1.5 mt-8'>
                  {subLinks.map((link, index) => (
                    <li key={index}>
                      <a className='font-bold [@media(hover:hover)]:hover:underline' href={Object.values(link)[0] as string}>{Object.keys(link)[0]}</a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
      <div role='contentinfo' className='pt-8 pb-6 px-8 lg:px-10 text-black'>
        <div className='space-y-6 max-w-6xl mx-auto'>
          <ul className='flex flex-col md:flex-row w-full gap-6 flex-wrap justify-evenyly'>
            {footerLinnksBottom.map((link, index) => (
              <li className='grow' key={index}>
                <a href={Object.values(link)[0] as string} className='[@media(hover:hover)]:hover:underline'>{Object.keys(link)[0]}</a>
              </li>
            ))}
          </ul>
          <p className='text-sm'>&copy; UDC Finance Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export { Footer }
